import { Button, Result } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { BookingProblem } from "../bookingRequest";
import BookingProblems from "../BookingProblems/BookingProblems";

interface Props {
  error: string;
  onRetry: () => void;
  // Company-specific problems with instructions; shown instead of the plain error when present
  problems?: BookingProblem[];
  companyId?: number;
}

const BookingError: React.FC<Props> = ({ error, onRetry, problems, companyId }) => {
  const hasProblems = problems !== undefined && problems.length > 0;

  return (
    <Result
      status="warning"
      title="Dere kan ikke booke akkurat nå"
      subTitle={
        hasProblems ? undefined : (
          <>
            {error}
            <br />
            Ta kontakt på <a href="mailto:bedrift@bindeleddet.no">bedrift@bindeleddet.no</a> dersom du mener dette er
            feil.
          </>
        )
      }
      extra={
        hasProblems
          ? [
              <Link key="info" to="/company/event-booking/">
                <Button>Tilbake til informasjon</Button>
              </Link>,
            ]
          : [
              <Button key="retry" type="primary" onClick={onRetry}>
                Prøv igjen
              </Button>,
              <Link key="info" to="/company/event-booking/">
                <Button>Tilbake til informasjon</Button>
              </Link>,
            ]
      }
      style={{ width: "100%" }}
    >
      {hasProblems && <BookingProblems problems={problems} companyId={companyId} onRecheck={onRetry} />}
    </Result>
  );
};

export default BookingError;
